import React from "react";
import { fireEvent, render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import { HeaderCell } from "./HeaderCell";

// jsdom does no layout, so each test says how wide the text is against the cell.
const setWidths = (cell: HTMLElement, scrollWidth: number) => {
  Object.defineProperty(cell, "scrollWidth", { value: scrollWidth });
  Object.defineProperty(cell, "clientWidth", { value: 100 });
};

const renderCell = () =>
  render(
    <table>
      <thead>
        <tr>
          <HeaderCell>Therapeutic Areas</HeaderCell>
        </tr>
      </thead>
    </table>,
  );

describe("HeaderCell", () => {
  it("shows the full heading on hover when it is cut short", async () => {
    renderCell();
    const cell = screen.getByRole("columnheader");
    setWidths(cell, 160);

    fireEvent.mouseOver(cell);

    expect(await screen.findByRole("tooltip")).toHaveTextContent(
      "Therapeutic Areas",
    );
  });

  it("shows nothing on hover when the heading fits", async () => {
    jest.useFakeTimers();
    try {
      renderCell();
      const cell = screen.getByRole("columnheader");
      setWidths(cell, 100);

      fireEvent.mouseOver(cell);
      jest.runAllTimers();

      expect(screen.queryByRole("tooltip")).not.toBeInTheDocument();
    } finally {
      jest.useRealTimers();
    }
  });
});
